import { v5 as uuidv5 } from "uuid";

/**
 * Never change this value. Every animation id in every environment depends on
 * it: the API derives `externalId` from `(animationState, layer)` with this
 * namespace, and this helper must reproduce that id byte-for-byte.
 */
export const ANIMATION_NAMESPACE = "98a49c96-04d9-434a-b602-fa237ffd8dcb";

/**
 * Content that predates the `layer` field defaults to layer 0. A different
 * default would derive a different id, so this value is part of the migration
 * contract and must not change either.
 */
export const DEFAULT_ANIMATION_LAYER = 0;

/**
 * Derives the API's `externalId` for an animation reference stored in training
 * content. Trim only, case preserved, layer as a plain decimal integer.
 *
 * Use this only for migrating existing content. Animations that come from the
 * API already carry `externalId`; read it from the response instead.
 */
export function deriveAnimationId(animationState: string, layer: number): string {
  return uuidv5(`${animationState.trim()}-${layer}`, ANIMATION_NAMESPACE);
}

/**
 * Empty and "none" states mean "no animation" in content and never map to an
 * API animation, so no id is derived for them.
 */
export function isDerivableAnimationState(
  animationState: string | undefined | null
): animationState is string {
  if (typeof animationState !== "string") return false;
  const trimmed = animationState.trim();
  return trimmed.length > 0 && trimmed.toLowerCase() !== "none";
}
